var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.4302 5.82115H2.98194L9.23551 0.392578C9.33551 0.305078 9.2748 0.142578 9.14266 0.142578H7.5623C7.49266 0.142578 7.42659 0.167578 7.3748 0.212221L0.626586 6.06758C0.56478 6.12115 0.515212 6.18739 0.481241 6.26179C0.447269 6.3362 0.429687 6.41703 0.429688 6.49883C0.429687 6.58062 0.447269 6.66146 0.481241 6.73586C0.515212 6.81027 0.56478 6.8765 0.626586 6.93008L7.41409 12.8211C7.44087 12.8444 7.47301 12.8569 7.50694 12.8569H9.14087C9.27302 12.8569 9.33373 12.6926 9.23373 12.6069L2.98194 7.17829H13.4302C13.5087 7.17829 13.573 7.11401 13.573 7.03543V5.96401C13.573 5.88544 13.5087 5.82115 13.4302 5.82115Z","fill":"#FBFAFC"}));
}

ArrowInline.defaultProps = {"width":"14","height":"13","viewBox":"0 0 14 13","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
